import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function IlluminatingFaithForTheYouth() {
  return <section data-section-id="224343" id="the-national-economic-pulse" className="relative w-full min-h-[90vh] flex items-center overflow-hidden dark bg-background text-foreground py-20 lg:py-32">
      {}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none mix-blend-overlay z-0" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          
          {}
          <div className="flex flex-col items-start gap-8 max-w-2xl">
            <div className="flex flex-col items-start gap-6">
              <h1 className="text-5xl md:text-7xl lg:text-8xl font-default font-bold leading-[1.1] tracking-tighter text-foreground">
                The Definitive <br />
                <span className="bg-gradient-to-r from-primary to-muted-foreground bg-clip-text text-transparent">Measure&nbsp;</span>
                <br /> of Economics
              </h1>
            </div>
            
            <p className="text-lg md:text-xl text-muted-foreground font-sans max-w-lg leading-relaxed">
              Independent household indicators providing the authoritative pulse of the Australian economic landscape.
            </p>
            
            <div className="flex gap-4">
              <Link to="/MethodologyPage">
                <Button size="lg" className="relative overflow-hidden group bg-primary text-primary-foreground hover:bg-primary/90 shadow-none transition-all duration-300 h-14 px-8 text-lg rounded-sm border border-primary/20">
                  <span className="relative z-10 font-default font-semibold tracking-wide">Explore the Data</span>
                  {}
                  <div className="absolute inset-0 -translate-x-[150%] bg-gradient-to-r from-transparent via-background/10 to-transparent group-hover:translate-x-[150%] transition-transform duration-1000 ease-in-out z-0" />
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div className="relative w-full aspect-square md:aspect-[4/3] lg:aspect-auto lg:h-[700px] mt-10 lg:mt-0">
            
            {}
            <div className="absolute top-[20%] left-[20%] w-[40%] h-[40%] bg-chart-1/10 rounded-full blur-[80px] pointer-events-none z-0" />
            <div className="absolute bottom-[20%] right-[20%] w-[45%] h-[45%] bg-chart-3/5 rounded-full blur-[100px] pointer-events-none z-0" />

            {}
            {}
            <div className="absolute top-0 right-0 w-[65%] h-[60%] rounded-sm overflow-hidden shadow-2xl z-20 border border-border/20 transform transition-transform duration-700 hover:scale-[1.01]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1664816/img/australia_glass_render.png" alt="3D glass rendering of the Australian continent" className="w-full h-full object-cover grayscale contrast-125" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1664816/img/australia_glass_render.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1664816/img/australia_glass_render.png-wvc-sizes" loading="lazy" />
            </div>

            {}
            <div className="absolute bottom-[5%] left-0 w-[55%] h-[50%] rounded-sm overflow-hidden shadow-xl z-30 border-2 border-background transform transition-transform duration-700 hover:scale-[1.01]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1664816/img/economic_data_visualization.png" alt="High-density economic data visualization" className="w-full h-full object-cover grayscale" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1664816/img/economic_data_visualization.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1664816/img/economic_data_visualization.png-wvc-sizes" loading="lazy" />
            </div>

            {}
            <div className="absolute top-[35%] left-[15%] w-[45%] h-[40%] rounded-sm overflow-hidden shadow-lg z-10 opacity-40 transform transition-transform duration-700 hover:scale-[1.01]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1664816/img/institutional_architecture.png" alt="Modern institutional architecture in Australia" className="w-full h-full object-cover grayscale" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1664816/img/institutional_architecture.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1664816/img/institutional_architecture.png-wvc-sizes" loading="lazy" />
            </div>
            
          </div>
        </div>
      </div>
    </section>;
}